import React from 'react';

import { Card as MuiCard } from '@material-ui/core';
import { CardProps as MuiCardProps } from '@material-ui/core/Card';

export type CardProps = MuiCardProps;

export const Card = (props: CardProps): JSX.Element => {
  const { children, ...rest } = props;

  return <MuiCard {...rest}>{children}</MuiCard>;
};
